import React, { useContext, useEffect, useState } from "react";
import "./Trade.scss";
import {
  Modal,
  Box,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography,
  IconButton,
  InputAdornment,
  ListSubheader,
} from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import usercalls from "../../Axios";
import consts from "../../constant";
import { useLocation, useNavigate } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import Context from "../../Context";
import { useUserData } from "../../Contexts/UserContext";
import toast from "react-hot-toast";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  "@media(max-width:767.98px)": {
    width: "80%",
  },
  maxWidth: 400,
  bgcolor: "var(--mdl)",
  borderRadius: 2,
  boxShadow: 24,
  p: 3,
};

function truncateToDecimals(num, decimals = 12) {
  const factor = Math.pow(10, decimals);
  return Math.floor(num * factor) / factor;
}

function Transfer({ changeType, setAssetChange, handOpen }) {
  const location = useLocation();
  var paths = location?.pathname?.split("/")[1];
  const path = usercalls();

  const { userData } = useUserData();

  const navigate = useNavigate();

  //setBalanceUpdate
  const { setBalanceUpdate, assetName, setAssetName } = useContext(Context);
  console.log("🚀 ~ Transfer ~ assetName:", assetName);
  const [fromAccount, setFromAccount] = useState("");
  const [toAccount, setToAccount] = useState("");
  const [amount, setAmount] = useState(0);
  const [open, setOpen] = useState(false);
  const [allPairs, setAllPairs] = useState([]);
  const [pairBalance, setPairBalance] = useState(0);
  const [fromType, setFromType] = useState("");
  const [toType, setToType] = useState("");
  const [load, setLoad] = useState(false);
  const [search, setSearch] = useState("");

  const token = window.localStorage.getItem("Rikosta");

  // useEffect(() => {
  //   setToAccount(assetName)
  // }, [assetName])

  const handleSwapAccounts = () => {
    const temp = fromAccount;
    setFromAccount(toAccount);
    setToAccount(temp);
  };

  const handleOnclose = () => {
    setAssetName("");
    setOpen(false);
    setToType("");
    // setFromType("");
    setToAccount("");
    setPairBalance(0);
    setAmount(0);
  };

  const getWalletsData = async (search) => {
    try {
      setAllPairs([]);
      const url = `${consts.BackendUrl}/wallet/OwnWalletGet?page=1&limit=1000`;
      const response = await path.postCall({
        url,
        payload: {
          search: "",
          hideZero: false,
          changeType:
            fromType == "MAIN"
              ? "spot"
              : fromType == "MARGIN"
                ? "margin"
                : fromType == "UMFUTURE"
                  ? "future"
                  : fromType == "FUNDING"
                    ? "funding"
                    : fromType == "BOT"
                      ? "bots"
                      : "",
        },
      });
      const result = await response.json();
      if (result.success) {
        setAllPairs(result.result.docs);
      }
    } catch (error) {
      console.log("🚀 ~ getWalletsData ~ error:", error);
    }
  };

  useEffect(() => {
    if (token && toType) {
      // console.log("🚀 ~ useEffect ~ toType:", toType)
      getWalletsData();
    }
  }, [toType, token]);

  const handleCoinChange = async (item) => {
    try {
      setSearch("");
      if (fromType == "MAIN") {
        setPairBalance(item?.spot_balance);
      } else if (fromType == "MARGIN") {
        setPairBalance(item?.margin_balance);
      } else if (fromType == "UMFUTURE") {
        setPairBalance(item?.future_balance);
      } else if (fromType == "FUNDING") {
        setPairBalance(item?.funding_balance);
      }
      setFromAccount(item?.symbol);
    } catch (error) {
      console.log(error, "error getting all coins");
    }
  };
  const [fromTypeError, setFromTypeError] = useState("");
  const [toTypeError, setToTypeError] = useState("");
  const [amountError, setAmountError] = useState("");
  const [toAccountError, setToAccountError] = useState("");

  const handleAssetTransfer = async () => {
    if (fromType == "") {
      setFromTypeError("Please Select From Wallet");
    } else if (toType == "") {
      setToTypeError("Please Select To Wallet");
    } else if (toAccount == "") {
      setToAccountError("Please Select Asset");
    } else if (amount <= 0) {
      setAmountError("Please Enter Valid Amount");
    } else {
      try {
        setLoad(true);
        const url = `${consts.BackendUrl}/ownTrade/internalTransfer`;
        const payload = {
          From: fromType, //"MAIN_MARGIN",
          To: toType,
          symbol: toAccount,
          Amount: amount,
        };
        // console.log(payload, "payload");
        const response = await path.postCall({ url, payload });
        const result = await response.json();

        if (result.success) {
          toast.success(result?.message);
          setBalanceUpdate(Math.random(6));
          setFromAccount("");
          setToAccount("");
          setAmount("");
          // setFromType("");
          setToType("");
          setPairBalance(0);
          setOpen(false);
          if (changeType) {
            setAssetChange(Math.random(6));
          }
        } else {
          toast.error(result?.message);
          setFromAccount("");
          setToAccount("");
          setAmount("");
          // setFromType("");
          setPairBalance(0);
          setToType("");
        }
      } catch (error) {
        console.log(error, "error getting all coins");
      } finally {
        setLoad(false);
      }
    }
  };

  useEffect(() => {
    if (location?.pathname === "/assets" && changeType == "spot") {
      setFromType("MAIN");
    } else if (location?.pathname === "/assets" && changeType == "margin") {
      setFromType("MARGIN");
    } else if (location?.pathname === "/assets" && changeType == "future") {
      setFromType("UMFUTURE");
    } else {
      setFromType("FUNDING");
    }
  }, [location?.pathname, changeType]);
  const handleOpen = () => {
    if (userData?.kyc_verify == "true") {
      setOpen(true);
    } else {
      navigate("/kycverify");
      toast.error("Verify KYC to Transfer");
    }
  };

  // useEffect(() => {
  //   if (handOpen) {
  //     handleOpen()
  //   }
  // }, [handOpen])

  return (
    <div>
      {/* <div className='transfer-btn' onClick={() => setOpen(true)}>
                Transfer
            </div> */}
      <Button variant="contained" onClick={() => handleOpen()}>
        Transfer{" "}
      </Button>

      <Modal
        open={open}
        onClose={() => {
          handleOnclose();
        }}
      >
        <Box sx={modalStyle} className="transfer-modal">
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
            <Typography
              variant="h6"
              sx={{ fontWeight: 600, color: "var(--clr-font)" }}
            >
              Transfer
            </Typography>
            <IconButton
              onClick={() => {
                handleOnclose();
              }}
              size="small"
            >
              <HighlightOffIcon size={20} sx={{ fill: "var(--clr-font)" }} />
            </IconButton>
          </Box>
          <div>
            <InputLabel>From</InputLabel>
          </div>
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel id="demo-simple-select-label">Select Type</InputLabel>
            <Select
              value={fromType}
              label="From"
              onChange={(e) => {
                setFromType(e.target.value);
                setFromTypeError("");
                setToAccount();
                setPairBalance(0);
              }}
              sx={{
                bgcolor: "var(--clr-grey)",
                fieldset: { border: "none" },
                color: "var(--clr-font)",
                svg: { fill: "var(--clr-font)" },
              }}
            >
              <MenuItem value="MAIN"> Spot</MenuItem>
              <MenuItem value="MARGIN">Cross Margin</MenuItem>
              {/* <MenuItem value="ISOLATEDMARGIN">Isolated Margin</MenuItem> */}
              <MenuItem value="UMFUTURE">Futures</MenuItem>
              <MenuItem value="FUNDING">Funding</MenuItem>
              <MenuItem value="BOT">Bots</MenuItem>
            </Select>
          </FormControl>
          <p style={{ color: "red", textAlign: "center" }}>
            {fromTypeError != "" ? fromTypeError : null}
          </p>
          <Box sx={{ display: "flex", justifyContent: "center", my: 1 }}>
            <IconButton
              onClick={handleSwapAccounts}
              sx={
                {
                  // bgcolor: '#f0f2f5',
                  // '&:hover': { bgcolor: '#e6e8eb' }
                }
              }
            >
              <ImportExportIcon size={20} sx={{ fill: "var(--clr-font)" }} />
            </IconButton>
          </Box>
          <div>
            <InputLabel>To</InputLabel>
          </div>
          <FormControl fullWidth sx={{ mt: 3 }}>
            {/* <InputLabel>To</InputLabel> */}
            <InputLabel id="demo-simple-select-label">Select Type</InputLabel>

            <Select
              value={toType}
              // label="To"
              onChange={(e) => {
                setToType(e.target.value);
                setToTypeError("");
                setToAccount();
                setPairBalance(0);
              }}
              sx={{
                bgcolor: "var(--clr-grey)",
                fieldset: { border: "none" },
                color: "var(--clr-font)",
                svg: { fill: "var(--clr-font)" },
              }}
            >
              <MenuItem value="MAIN"> Spot</MenuItem>
              <MenuItem value="MARGIN">Cross Margin</MenuItem>
              {/* <MenuItem value="ISOLATEDMARGIN">Isolated Margin</MenuItem> */}
              <MenuItem value="UMFUTURE">Futures</MenuItem>
              <MenuItem value="FUNDING">Funding</MenuItem>
              <MenuItem value="BOT">Bots</MenuItem>
            </Select>
          </FormControl>
          <p style={{ color: "red", textAlign: "center" }}>
            {toTypeError != "" ? toTypeError : null}
          </p>
          <div>
            <InputLabel>Coin</InputLabel>
          </div>
          <FormControl fullWidth sx={{ mt: 3 }}>
            {/* <InputLabel>To</InputLabel> */}
            <InputLabel id="demo-simple-select-label">Select Coin</InputLabel>

            <Select
              value={toAccount}
              // label="To"
              onChange={(e) => {
                setToAccount(e.target.value);
                setAmount(0);
                setToAccountError("");
              }}
              sx={{
                bgcolor: "var(--clr-grey)",
                fieldset: { border: "none" },
                color: "var(--clr-font)",
                svg: { fill: "var(--clr-font)" },
              }}
            >
              <ListSubheader
                sx={{
                  backgroundColor: "var(--mui-select-bg) !important",
                  zIndex: 10,
                  position: "sticky",
                  top: "-10px",
                  paddingTop: "10px",
                }}
              >
                <TextField
                  className="transfer-search"
                  size="small"
                  placeholder="Search..."
                  fullWidth
                  autoFocus
                  onChange={(e) => setSearch(e.target.value)}
                  onKeyDown={(e) => e.stopPropagation()}
                />
              </ListSubheader>

              {toType != "UMFUTURE" && fromType != "UMFUTURE"
                ? allPairs
                    ?.filter((item) =>
                      item?.symbol
                        ?.toLowerCase()
                        ?.includes(search?.toLowerCase()),
                    )
                    ?.map((item, index) => (
                      <MenuItem
                        onClick={() => handleCoinChange(item)}
                        key={index}
                        value={item?.symbol}
                      >
                        {/* <img style={{ width: "30px", height: "30px", marginRight: "10px" }} src={item?.asset_id?.imageurl} alt={item?.symbol} /> */}
                        {item?.symbol}
                      </MenuItem>
                    ))
                : allPairs
                    ?.filter((item) => item?.symbol == "USDT")
                    ?.map((item, index) => (
                      <MenuItem
                        onClick={() => handleCoinChange(item)}
                        key={index}
                        value={item?.symbol}
                      >
                        {/* <img style={{ width: "30px", height: "30px", marginRight: "10px" }} src={item?.asset_id?.imageurl} alt={item?.symbol} /> */}
                        {item?.symbol}{" "}
                      </MenuItem>
                    ))}

              {/* <MenuItem value="funding">BTC</MenuItem>
                            <MenuItem value="margin">ETH</MenuItem> */}
            </Select>
          </FormControl>
          <p style={{ color: "red", textAlign: "center" }}>
            {toAccountError != "" ? toAccountError : null}
          </p>
          <div>
            <InputLabel>Amount</InputLabel>
          </div>
          <TextField
            fullWidth
            // label="Amount"
            value={amount}
            onChange={(e) => {
              setAmount(e.target.value);
              setAmountError("");
            }}
            type="number"
            sx={{
              mb: 2,
              bgcolor: "var(--clr-grey)",
              fieldset: { border: "none" },
              input: { color: "var(--clr-font)" },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Button
                    onClick={(e) => {
                      setAmount(truncateToDecimals(pairBalance));
                      setAmountError("");
                    }}
                    size="small"
                    sx={{
                      minWidth: "auto",
                      px: 1,
                      color: "var(--clr-font)",
                      bgcolor: "transparent",
                      textTransform: "capitalize",
                      // texttransform: 'capitalise !important'
                    }}
                  >
                    Max
                  </Button>
                </InputAdornment>
              ),
            }}
          />
          <p style={{ color: "red", textAlign: "center" }}>
            {amountError != "" ? amountError : null}
          </p>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              mb: 3,
              color: "var(--clr-font)",
              fontSize: "0.875rem",
            }}
          >
            {/* <Info size={16} /> */}
            <Typography variant="body2">
              Available: {truncateToDecimals(Number(pairBalance))} {toAccount}
            </Typography>
          </Box>

          <Button
            disabled={load}
            fullWidth
            variant="contained"
            sx={{
              py: 0.8,
              bgcolor: "#566fff !important",
              color: "#fff",
              textTransform: "capitalize",
            }}
            onClick={handleAssetTransfer}
          >
            Transfer
          </Button>
        </Box>
      </Modal>
    </div>
  );
}

export default Transfer;
